export const UNI = {
  addr: '0xA77d09743F77052950C4eb4e6547E9665299BecD',
  decimals: 18,
  symbol: 'T-3CRV',
}

export const USDC = {
  addr: '0x6c3f90f043a72fa612cbac8115ee7e52bde6e490',
  decimals: 18,
  symbol: '3CRV',
}

export const ESD = {
  addr: '0x6967299e9F3d5312740Aa61dEe6E9ea658958e31',
  decimals: 18,
  symbol: 'T',
}

export const ESDS = {
  addr: '0x883B01205b938EC7268286d13Cb40a2045D2E78F',
  decimals: 18,
  symbol: 'TS',
}
